import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import CustomDataDownload from "../components/SOD/CustomDownload/CustomDownload";
import { Dispatch } from "redux";
import * as actions from "../common/actions";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
    uuid: appState,
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateFilter: (filterField: string, value: string | number) => {
      dispatch(actions.updateFilter(filterField, value));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CustomDataDownload);
